























































































import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/main.ts";
import { Getter } from "vuex-class";
import ContractDeleteModal from "@/components/contracts/modals/ContractDeleteModal.vue";
import { Contract } from "@/services/contracts/types";
import { getContracts } from "@/services/contracts/contractService";
import { contractsFields } from "@/components/contracts/fields/contractsFields";

@Component({
    components: {
        ContractDeleteModal
    }
})
export default class Contracts extends Vue {
    @Getter("reload") reload: any;

    // local state
    contracts = [] as Array<Contract>;
    fields = contractsFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchQuery = "";

    // lifecycle hooks
    public created(): void {
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // computed

    get filteredData() {
        return this.contracts && this.contracts
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                (x.number != null && x.number.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    fetchData() {
        this.isBusy = true;
        getContracts().then(response => {
            this.contracts = response;
            this.isBusy = false;
        });
    }

    deleteContract(contractId: string, contractName: string) {
        (this.$refs.contractDeleteModal as any)
            .open(contractId, contractName);
    }
}
